var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"100px"}}),_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Loading...")])]),_c('div',{staticStyle:{"height":"75px"}})])
}]

export { render, staticRenderFns }